import * as globals from './globals.js';

export default class Membership {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    if (this.el.querySelector('.form-component-outer')) {
      this.attachEvents();
    }
    this.initSelectBoxes();

    $('select').on('click', function (event) {
      event.stopPropagation();
    });
  }

  attachEvents() {
    const showFormButton = this.el.querySelector('button.show-form'),
      innerContent = this.el.querySelector('.inner-content'),
      thankyouContent = this.el.querySelector('.thankyou-content'),
      formWrapper = this.el.querySelector('.form-component-outer'),
      form = formWrapper.querySelector('form'),
      formAction = form.getAttribute('action'),
      that = this;

    showFormButton.addEventListener('click', (event) => {
      innerContent.classList.add('hide');
      formWrapper.classList.add('show');
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const formContent = new FormData(form),
        fetchOptions = {
          method: 'POST',
          mode: 'same-origin',
          credentials: 'include',
          body: formContent,
        };

      if ($(form).valid()) {
        fetch(formAction, fetchOptions)
          .then((response) => {
            formWrapper.classList.remove('show');
            thankyouContent.classList.add('show');
            thankyouContent.focus();
          })
          .catch((error) => {
            console.error('Error submitting form:', error);
          });
      } else {
        console.warn('Form not valid!');
      }
    });
  }

  initSelectBoxes() {
    const selectBoxes = Array.prototype.slice.call(this.el.querySelectorAll('select'));

    selectBoxes.forEach((select) => {
      const parentEl = select.parentNode;
      let wrapperEl = document.createElement('div');
      wrapperEl.classList.add('select-wrapper');
      wrapperEl.innerHTML = `<i class="fa fa-chevron-down"></i>`;
      parentEl.insertBefore(wrapperEl, select);
      wrapperEl.appendChild(select);
    });
  }
}
